import React from "react";

const LoadingFallback = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-lg font-semibold">Loading...</p>
    </div>
  );
};

export default LoadingFallback;
// import React from "react";
// import barloading from "../../assets/images/barLoading.svg";

// const LoadingFallback = () => {
//   return (
//     <div className="flex items-center justify-center min-h-screen bg-background">
//       <div className="flex flex-col items-center space-y-6">
//         {/* SVG Loading Image */}
//         <img
//           src={barloading}
//           alt="Loading..."
//           className="w-48 h-auto animate-pulse"
//         />

//         {/* Optional Text */}
//         <p className="text-lg font-medium text-gray-600 dark:text-gray-300">
//           Loading, please wait...
//         </p>
//       </div>
//     </div>
//   );
// };

// export default LoadingFallback;
